import React from "react";
import DataTable from "../../../components/DataTable";

const AcademicSessions = () => (
  <DataTable
    title="Academic Sessions"
    apiPath="/api/admin/master/academic-sessions"
    columns={[
      { key: "id", label: "ID" },
      { key: "name", label: "Name" },
      { key: "isActive", label: "Active" },
    ]}
    formFields={[
      { key: "name", label: "Name (e.g. 2025-26)", required: true },
      { key: "startDate", label: "Start Date", type: "date" },
      { key: "endDate", label: "End Date", type: "date" },
      { key: "isActive", label: "Active", type: "checkbox", defaultValue: true },
    ]}
    transformSubmit={(data) => ({
      name: data.name,
      startDate: data.startDate || null,
      endDate: data.endDate || null,
      isActive: data.isActive ?? true,
    })}
  />
);

export default AcademicSessions;
